import styled from 'styled-components'
import arrowDown from '../../../../../assets/certificates/AddCertificate/arrow-down.svg'
import whiteArrowDown from '../../../../../assets/certificates/AddCertificate/white-arrow-down.svg'

export const Container = styled.div`
    padding: 1rem .5rem;
    border-radius: 0.7rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: #fff;
`

export const InputDiv = styled.div`
    position: relative;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    .empty {
        border: 0;
    }

    .isDisabled {
       cursor: not-allowed;
    }
`

export const InputLabel = styled.label`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
`

export const InputFeio = styled.input`
    height: 2.2rem;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 1.84rem;
    padding-left: 0.92rem;
    padding-right: 0.92rem;
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);

    &.disabled{
        border: 1px solid #e1e1e1;
        background-image: url(${whiteArrowDown});
        background-repeat: no-repeat;
        background-position-x: 95%;
        background-position-y: 50%;
        background-size: 1.2rem;
        cursor: not-allowed;
        background-color: #939393;
        ::placeholder {
            color: #494949;
        }
    }

    :focus {
        outline: 0;
    }
`

export const StyledSelect = styled.select` //tipo de certificado
    background-color: #ebebeb;
    color: #777777;
    height: 2.2rem;
    width: 100%;
    font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);
    padding-left: 0.92rem;
    padding-right: 2.15rem;
    border-radius: 1.78rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-size: 1.2rem;

    :focus{
        outline: 0;
    }
`

export const DisabledSelect = styled.select` // não permitido a alteração da empresa
    position: relative;
    bottom: 1px;
    background-color: #696969;
    width: 100%;
    color: #000;
    height: 2.2rem;
    font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);
    padding-left: 0.92rem;
    padding-right: 2.15rem;
    border-radius: 1.78rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${whiteArrowDown});
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-size: 1.2rem;
    cursor: not-allowed;

    :focus{
        outline: 0;
    }
`

export const StyledOption = styled.option`
    background-color: #fff;
    height: 0.7rem;
    font-size: clamp(0.5rem, calc(0.6rem + 0.1vw) , 1.3rem);
`

export const DropdownMenu = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 12rem;
    max-height: 28rem;
    padding-right: 1.8rem;
    top: 3.7rem;
    background-color: #fff;
    border: 1px solid #000;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;
`

export const OptionDiv = styled.div`
    display: flex;
    width: 12rem;
    justify-content: center;
    align-items: center;
    min-height: 1.5rem;
    max-height: 1.5rem;
    cursor: pointer;

    :hover{
        background-color: #EBEBEB;
    }
`

export const OptionText = styled.p`
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.3rem);
    font-family: 'Inter', sans-serif;
`

export const StyledSelectCertificate = styled.div`
    position: relative;
    background-color: #ebebeb;
    color: #777777;
    height: 2.2rem;
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);
    line-height: 2.2rem;
    padding-left: 0.92rem;
    padding-right: 2.15rem;
    border-radius: 1.78rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-size: 1.2rem;

    :focus{
        outline: 0;
    }
`

export const ClientDropdownMenu = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 12rem;
    // height: 7rem;
    max-height: 26rem;
    padding-bottom: 0.15rem;
    top: 2.3rem;
    right: 0.2rem;
    background-color: #fff;
    border: 1px solid #ebebeb;
    border-top-left-radius: 0.8rem;
    border-bottom-left-radius: 0.8rem;
    border-bottom-right-radius: 0.8rem;
    box-shadow: 0px 8px 16px 0px #0000001A;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;
    
    .addDiv {
        border-bottom: 2px solid #ebebeb;
        min-height: 2.2rem;
        max-height: 2.2rem;
    }

    .addText {
        margin-left: 0.4rem;
    }
`

export const ClientOptionDiv = styled.div`
    display: flex;
    width: 12rem;
    align-items: center;
    min-height: 1.9rem;
    max-height: 1.9rem;
    cursor: pointer;

    :hover{
        background-color: #EBEBEB;
    }
`

export const ClientOptionPlusImg = styled.img`
    margin-left: 0.8rem;
    width: 0.8rem;
`

export const ClientOptionText = styled.p`
    margin-left: 0.8rem;
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.3rem);
    font-family: 'Inter', sans-serif;
`